import { GroupBadge } from "./GroupBadge";
import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { Badge } from "@/components/ui/badge";

interface GroupBadgeListProps {
	groups: Pick<Dryp.StructureGroup, "id" | "name">[];
	selectedIds?: Set<Dryp.StructureGroupId>;
	onBadgeClick?: (id: Dryp.StructureGroupId) => void;
	maxVisible?: number;
}

export const GroupBadgeList: React.FC<GroupBadgeListProps> = ({
	groups,
	selectedIds = new Set(),
	onBadgeClick,
	maxVisible = 3,
}) => {
	if (groups.length <= maxVisible) {
		return (
			<div className="flex flex-wrap gap-1">
				{groups.map(group => (
					<GroupBadge
						key={group.id}
						name={group.name}
						selected={selectedIds.has(group.id)}
						onClick={() => onBadgeClick?.(group.id)}
					/>
				))}
			</div>
		);
	}

	const visibleGroups = groups.slice(0, maxVisible - 1);
	const hiddenGroups = groups.slice(maxVisible - 1);

	return (
		<div className="flex flex-wrap gap-1">
			{visibleGroups.map(group => (
				<GroupBadge
					key={group.id}
					name={group.name}
					selected={selectedIds.has(group.id)}
					onClick={() => onBadgeClick?.(group.id)}
				/>
			))}

			<DropdownMenu>
				<DropdownMenuTrigger asChild>
					<Badge variant="outline" className="cursor-pointer text-[10px] px-1 py-0 rounded-md">
						+{hiddenGroups.length} more
					</Badge>
				</DropdownMenuTrigger>
				<DropdownMenuContent className="max-h-64 overflow-y-auto p-2 space-y-1" align="start" sideOffset={4}>
					{hiddenGroups.map(group => (
						<GroupBadge
							key={group.id}
							name={group.name}
							selected={selectedIds.has(group.id)}
							onClick={() => onBadgeClick?.(group.id)}
							className="w-fit"
						/>
					))}
				</DropdownMenuContent>
			</DropdownMenu>
		</div>
	);
};
